import React, { useEffect, useState } from "react";

//UI Material
import { Breadcrumbs, Grid, Link } from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Local components
import ClientSummary from "../Components/client-page/ClientSummary";
import ErrorBox from "../Components/ErrorBox";
import ClientInfo from "../Components/client-page/ClientInfo";
import ClientProducts from "../Components/client-page/ClientProducts";
import ClientQuotes from "../Components/client-page/ClientQuotes";
import DataLoader from "../Components/basics/DataLoader";

export default function Client() {
  // ==========> Component States <==========
  //State for store client data
  const [clientData, setClientData] = useState({});
  //State for loading
  const [isLoading, setIsLoading] = useState(true);
  //State for error case
  const [dataError, setDataError] = useState(false);


  // ==========> Component Functions <==========
  //Function to get client data from db
  const getClientData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/clients/get-client`,
        {
          clientId: Number(
            new URLSearchParams(window.location.search).get("id")
          ),
        }
      );
      const jsonResponse = await requestResponse.json();
      setClientData(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setIsLoading(false);
  };

  //The useEffect checks for token validation
  useEffect(() => {
    getClientData();
  }, []);

  if (isLoading) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      textAlign="center"
      sx={{ padding: "15px" }}
    >
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/clients">
            Clientes
          </Link>

          <Link underline="hover" color="text.primary" aria-current="page">
            {`Cliente ${clientData.id}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <ClientSummary data={clientData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={1} alignItems="stretch" alignContent="stretch">
          <Grid item xs={12}>
            <ClientInfo data={clientData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ClientProducts products={clientData.products} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ClientQuotes quotes={clientData.quotes} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
